    @if (crumbs().length > 1) {
      <nav class="breadcrumb-bar" aria-label="Breadcrumb">
        <ol class="breadcrumb">
          @for (crumb of crumbs(); track crumb.label; let last = $last) {
            <li class="breadcrumb-item" [class.breadcrumb-item--active]="last">
              @if (!last && crumb.path) {
                <a [routerLink]="crumb.path">{{ crumb.label }}</a>
              } @else {
                <span>{{ crumb.label }}</span>
              }
            </li>
          }
        </ol>
      </nav>
    }
